import * as React from 'react'
import UserSubscriptionDetail from './user-subscription-detail'

export const UserSubscriptionsDetailPage: React.FC = () => (
  <div className="flex flex-col space-y-8">
    <UserSubscriptionDetail />
  </div>
)
